module.exports = __webpack_public_path__ + "static/media/IMG_0875.97478245.jpg";